import ErrorHandlingForm from "../../../components/formValidation/ErrorHandlingForm";
import {MenuItem, Stack} from "@mui/material";
import {useState} from "react";
import Typography from "@mui/material/Typography";
import CustomSelect from "../../../components/formValidation/CustomSelect";
import {validateOneOf, validateRequired} from "../../../components/formValidation/validators";
import {formatHuman} from "../../../utils/dateUtils";
import CustomDatePicker from "../../../components/formValidation/CustomDatePicker";

const InvoiceAdditionalData = ({reference}) => {
    const [data, setData] = useState({
        payment_method: 'bankcard',
        due_date: formatHuman(new Date()),
        fulfillment_date: formatHuman(new Date()),
    })
    const [errors, setErrors] = useState({
        payment_method: false,
        due_date: false,
        fulfillment_date: false,
    })
    const validators = {
        payment_method: [validateRequired, value => validateOneOf(value, ['cash', 'wiretransfer', 'bankcard', 'online'])],
        due_date: [validateRequired],
        fulfillment_date: [validateRequired],
    }

    return <ErrorHandlingForm
        data={data}
        setData={setData}
        errors={errors}
        setErrors={setErrors}
        validators={validators}
        reference={reference}
    >
        <Stack spacing={1}>
            <Stack spacing={1}>
                <Typography id="payment-method-label" variant="caption" color='primary.main'>
                    Fizetési mód*
                </Typography>
                <CustomSelect
                    data={data}
                    setData={setData}
                    errors={errors}
                    setErrors={setErrors}
                    validators={validators}
                    name="payment_method"
                    variant="standard"
                    inputProps={{
                        "aria-labelledby": "payment-method-label",
                        "aria-required": "true",
                    }}
                >
                    <MenuItem value='cash'>Készpénz</MenuItem>
                    <MenuItem value='wiretransfer'>Átutalás</MenuItem>
                    <MenuItem value='bankcard'>Bankkártya</MenuItem>
                    <MenuItem value='online'>Online</MenuItem>
                </CustomSelect>
            </Stack>
            <Stack spacing={1}>
                <Typography id="due-date-label" variant="caption" color='primary.main'>
                    Fizetési határidő*
                </Typography>
                <CustomDatePicker
                    data={data}
                    setData={setData}
                    errors={errors}
                    setErrors={setErrors}
                    validators={validators}
                    name="due_date"
                    variant="standard"
                    disablePast
                    inputProps={{
                        "aria-labelledby": "due-date-label",
                        "aria-required": "true",
                    }}
                />
            </Stack>
            <Stack spacing={1}>
                <Typography id="fulfillment-date-label" variant="caption" color='primary.main'>
                    Teljesítés dátuma*
                </Typography>
                <CustomDatePicker
                    data={data}
                    setData={setData}
                    errors={errors}
                    setErrors={setErrors}
                    validators={validators}
                    name="fulfillment_date"
                    variant="standard"
                    inputProps={{
                        "aria-labelledby": "fulfillment-date-label",
                        "aria-required": "true",
                    }}
                />
            </Stack>
        </Stack>
    </ErrorHandlingForm>
}

export default InvoiceAdditionalData